import { render, staticRenderFns } from "./inversetment_record.vue?vue&type=template&id=76bf0bb6&"
import script from "./inversetment_record.vue?vue&type=script&lang=js&"
export * from "./inversetment_record.vue?vue&type=script&lang=js&"
import style0 from "./inversetment_record.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports